module.exports = __webpack_public_path__ + "img/art-school-icon10.49b94685.png";